import { render, staticRenderFns } from "./BannerContacto.vue?vue&type=template&id=cdc3383a&"
import script from "./BannerContacto.vue?vue&type=script&lang=js&"
export * from "./BannerContacto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports